import { UserListResponse, UserPermissionsUpdateResponse } from '@/types/service/userManagement';

import { baseProtectedApi } from '@/store/baseApi';

export const userManagementApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserList: builder.query<UserListResponse, void>({
      query: () => ({
        url: '/v1/protected/users',
        method: 'GET',
      }),
    }),
    updateUserPermissions: builder.mutation<
      UserPermissionsUpdateResponse,
      { userId: number; permissions: Record<string, boolean> }
    >({
      query: ({ userId, permissions }) => ({
        url: `/v1/protected/users/${userId}/permissions`,
        method: 'PATCH',
        data: { permissions },
      }),
    }),
  }),
});

export const { useGetUserListQuery, useUpdateUserPermissionsMutation } = userManagementApi;
